import { MonitorsComponent } from './monitors.component';
import { AuthGuard } from '../../../../common/services/Auth.guard';

export const MonitorsRoute = [
  {
    path: 'monitors',
    component: MonitorsComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'activities', pathMatch: 'full' },
      {
        path: 'activities',
        component: MonitorsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'call-center',
        component: MonitorsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'channels',
        component: MonitorsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'agents',
        component: MonitorsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'call-monitor',
        component: MonitorsComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/monitors/monitors.route.ts